type Props = {
    readOnly: boolean;
    savingDraft: boolean;
    submitting: boolean;
    draftHint: string | null;
    submitHint: string | null;
    onSaveDraft: () => void;
    onSubmit: () => void;
};

const MenteeRegistrationActions = ({
    readOnly,
    savingDraft,
    submitting,
    draftHint,
    submitHint,
    onSaveDraft,
    onSubmit,
}: Props) => {
    if (readOnly) return null;
    return (
        <footer className="mreg-submit-panel">
            <h2 className="mreg-submit-title">Ready to Submit?</h2>
            <p className="mreg-submit-copy">
                Once submitted, the programme admin will use your responses to match you with the most suitable
                mentor. You&apos;ll be notified when a match is confirmed.
            </p>
            {draftHint ? <p className="mreg-action-msg is-ok">{draftHint}</p> : null}
            {submitHint ? <p className="mreg-action-msg is-err">{submitHint}</p> : null}
            <div className="mreg-action-row">
                <button
                    type="button"
                    className="btn mreg-btn-draft"
                    disabled={savingDraft || submitting}
                    onClick={onSaveDraft}
                >
                    {savingDraft ? 'Saving…' : 'Save as Draft'}
                </button>
                <button
                    type="button"
                    className="btn mreg-btn-submit"
                    disabled={savingDraft || submitting}
                    onClick={onSubmit}
                >
                    {submitting ? 'Submitting…' : '✅ Submit Registration'}
                </button>
            </div>
            <p className="mreg-submit-foot">
                You can update your preferences any time before the matching process runs.
            </p>
        </footer>
    );
};

export default MenteeRegistrationActions;
